/**
 * Blog timestamps arrive as MySQL strings ("2025-09-10 08:38:08"), which Safari
 * refuses to parse, and legacy rows can hold "0000-00-00 00:00:00". Both cases
 * render as an empty string rather than "Invalid Date".
 */
export const formatBlogDate = (value) => {
  if (!value) return '';

  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
